import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from '../common';

const NavBarItem = (props) => {
  const { route, icon, text, active, handleClick = () => { }, badge: { tooltip, action } = {}, newFeatureMessage = false } = props;

  return (
    <li id={`${text}-navbar-item-li`} className="navbar-item">
      <Link id={`${text}-navbar-link`} to={route} className={`navbar-link ${active ? 'active' : ''}`} onClick={handleClick}>
        <span id={`${text}-navbar-item-icon-span`} className="navbar-item-icon">
          <FontAwesomeIcon icon={{ prefix: 'fal', iconName: icon }} size="lg" id={text} />
          {action && <Badge action={action} tooltip={tooltip} />}
        </span>
        <div id={`${text}-navbar-item-text-div`} className="navbar-item-text">
          {text} {newFeatureMessage && <span className="rounded-title feature-budget">New</span>}
        </div>
      </Link>
    </li>
  );
};

NavBarItem.propTypes = {
  route: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  handleClick: PropTypes.func,
};

NavBarItem.defaultProps = {
  handleClick: () => null,
};

export default NavBarItem;
